(function(){
  Pegasus.IconsImagesController = Em.Controller.extend({
    needs: ['imageGallery', 'upload', 'frameCommManager'],
    staggerResults: false,
    breakValue: 5,
    request: function(query, page, count) {
      var params = [
        '&page=' + page
      ];

      var baseURL = '/icons_search.json?query=' + query;

      this.get('controllers.frameCommManager').requestIconImagesFor(
        baseURL + params.join('&'), this
      );
    },
    didCompleteRequest: function(data){
      var photos = data.photos;
      photos = photos.reduce(function(accum, i) {
        // This creates a security exception in Safari and ie11.
        // It may be worth retesting this capability sometime in the
        // future.
        if ( $(i.preview).find('switch').length || $(i.preview).find('foreignObject').length ) {
          return accum;
        }
        accum.push( i );
        return accum;
      }, []);
      data.photos = photos;
      Em.run( this.get('controllers.imageGallery'), 'send', 'didRetrieveImages', data, this);
    },
    useThis: function(view){
      var content = view.get('content');
      var src;

      src = $('<div>').append( view.$('svg') )[0].innerHTML;

      this.set('controllers.upload.dataSrcProxy', src);
      this.get('controllers.upload').send('didReplaceImage');
    },
    didSelectImage: function(){
    },
    didFailRequest: function(err){
    },
    sizeContent: Em.K
  });
})();

